'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dRecipe$002dSort from "./mealorama.-Recipe-Sort.js";
var $p;
/** @constructor */
function $c_Lmealorama_RecipeSort$() {
}
export { $c_Lmealorama_RecipeSort$ as $c_Lmealorama_RecipeSort$ };
$p = $c_Lmealorama_RecipeSort$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_RecipeSort$;
/** @constructor */
function $h_Lmealorama_RecipeSort$() {
}
export { $h_Lmealorama_RecipeSort$ as $h_Lmealorama_RecipeSort$ };
$h_Lmealorama_RecipeSort$.prototype = $p;
$p.m = (function() {
  return "RecipeSort";
});
$p.aSs = (function(x$0) {
  return new $j_mealorama$002e$002dRecipe$002dSort.$c_Lmealorama_RecipeSort(x$0.g(0), x$0.g(1));
});
var $d_Lmealorama_RecipeSort$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_RecipeSort$, "mealorama.RecipeSort$", ({
  GO: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_RecipeSort$ as $d_Lmealorama_RecipeSort$ };
var $n_Lmealorama_RecipeSort$;
function $m_Lmealorama_RecipeSort$() {
  if ((!$n_Lmealorama_RecipeSort$)) {
    $n_Lmealorama_RecipeSort$ = new $c_Lmealorama_RecipeSort$();
  }
  return $n_Lmealorama_RecipeSort$;
}
export { $m_Lmealorama_RecipeSort$ as $m_Lmealorama_RecipeSort$ };
//# sourceMappingURL=mealorama.-Recipe-Sort$.js.map
